// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Link = require("next/link").default;
var Icon__Jsx3 = require("../Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var TailwindMerge = require("tailwind-merge");
var TailwindVariants = require("../../../../v5/bindings/TailwindVariants.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var TailwindVariants$1 = require("tailwind-variants");
var ReactAriaComponents = require("react-aria-components");

var buttonBase = TailwindVariants$1.tv({
      extend: TailwindVariants.Utils.focusRing,
      base: "inline-flex shadow-none font-normal text-center items-center justify-center border border-solid duration-150 cursor-pointer whitespace-nowrap relative bg-transparent \n    disabled:pointer-events-none aria-disabled:pointer-events-none rounded-md",
      variants: {
        size: {
          small: "text-[13px] font-medium px-2.5 py-1 min-h-8",
          medium: "text-base font-semibold px-[15px] py-1.5 uppercase",
          large: "text-base font-semibold px-5 py-1.5 uppercase",
          huge: "text-lg font-semibold px-10 py-2 uppercase"
        }
      }
    });

var buttonPrimary = TailwindVariants$1.tv({
      extend: buttonBase,
      base: "bg-tan-blue-500 text-white border border-tan-blue-500 hover:border-tan-gold-light hover:bg-tan-gold-light hover:text-white focus:text-white \n      disabled:border-transparent aria-disabled:border-transparent \n      disabled:bg-tan-blue-500/50 aria-disabled:bg-tan-blue-500/50"
    });

var buttonSecondary = TailwindVariants$1.tv({
      extend: buttonBase,
      base: "border-zinc-300 text-zinc-600 bg-white hover:border-tan-blue-500 hover:text-white hover:bg-tan-blue-500 \n      disabled:border-zinc-300/50 aria-disabled:border-zinc-300/50 \n      disabled:text-zinc-600/50 aria-disabled:text-zinc-600/50 \n      disabled:bg-white/50 aria-disabled:bg-white/50"
    });

var buttonDarkSecondary = TailwindVariants$1.tv({
      extend: buttonBase,
      base: "border-tan-big-stone-alt text-zinc-300 bg-tan-big-stone-alt hover:border-tan-blue-500 hover:text-white hover:bg-tan-blue-500 \n      disabled:border-tan-big-stone-alt/50 aria-disabled:border-tan-big-stone-alt/50 \n      disabled:text-zinc-300/50 aria-disabled:text-zinc-300/50 \n      disabled:bg-tan-big-stone-alt/50 aria-disabled:bg-tan-big-stone-alt/50"
    });

var buttonCta = TailwindVariants$1.tv({
      extend: buttonBase,
      base: "border-tan-gold-light text-white bg-tan-gold-light hover:border-tan-gold-light hover:text-tan-gold-light hover:bg-white \n      disabled:border-transparent aria-disabled:border-transparent\n      disabled:bg-tan-gold-light/50 aria-disabled:bg-tan-gold-light/50"
    });

var buttonLink = TailwindVariants$1.tv({
      extend: TailwindVariants.Utils.focusRing,
      base: "text-tan-blue-500"
    });

var buttonDanger = TailwindVariants$1.tv({
      extend: buttonBase,
      base: "bg-tan-error-500 border-tan-error-500 text-white hover:border-tan-error-700 hover:bg-tan-error-700 hover:text-white focus:text-white \n      disabled:border-transparent aria-disabled:border-transparent\n      disabled:bg-tan-error-500/50 aria-disabled:bg-tan-error-500/50"
    });

var buttonOutline = TailwindVariants$1.tv({
      extend: buttonBase
    });

var Styles = {
  buttonBase: buttonBase,
  buttonPrimary: buttonPrimary,
  buttonSecondary: buttonSecondary,
  buttonDarkSecondary: buttonDarkSecondary,
  buttonCta: buttonCta,
  buttonLink: buttonLink,
  buttonDanger: buttonDanger,
  buttonOutline: buttonOutline
};

function ButtonsV5$BaseButton(props) {
  var styleFn = props.styleFn;
  var appearance = props.appearance;
  var __children = props.children;
  var ___type = props._type;
  var id = props.id;
  var ariaExpanded = props.ariaExpanded;
  var overlayText = props.overlayText;
  var icon = props.icon;
  var __className = props.className;
  var __size = props.size;
  var disabled = props.disabled;
  var onBlur = props.onBlur;
  var onFocus = props.onFocus;
  var onMouseEnter = props.onMouseEnter;
  var onClick = props.onClick;
  var tabIndex = props.tabIndex;
  var href = props.href;
  var size = __size !== undefined ? __size : "medium";
  var className = __className !== undefined ? __className : "";
  var _type = ___type !== undefined ? ___type : "submit";
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
  var content = JsxRuntime.jsxs(JsxRuntime.Fragment, {
        children: [
          icon !== undefined ? JsxRuntime.jsx(Icon__Jsx3.make, {
                  icon: icon,
                  className: "mr-2.5"
                }) : null,
          overlayText !== undefined ? JsxRuntime.jsx("div", {
                  children: overlayText,
                  className: TailwindMerge.twMerge([
                        "absolute bg-tan-gold-light text-white uppercase text-[10px] leading-[1.2] rounded-[3px] py-[1px] px-1.5 border border-tan-gold-light top-0 right-0 whitespace-nowrap translate-x-[10%] -translate-y-1/2",
                        appearance !== undefined ? (
                            appearance === "cta" ? "bg-white text-tan-gold-light border border-tan-gold-light" : (
                                appearance === "primary" ? "bg-white text-tan-blue-500 border border-tan-blue-500" : ""
                              )
                          ) : ""
                      ])
                }) : null,
          children
        ]
      });
  if (href !== undefined) {
    return JsxRuntime.jsx(Link, {
                href: disabled === true ? "#" : href,
                className: TailwindMerge.twMerge([
                      styleFn({
                            size: size,
                            isFocusVisible: false
                          }),
                      className
                    ]),
                "aria-disabled": disabled,
                onFocus: onFocus,
                onBlur: onBlur,
                tabIndex: tabIndex,
                children: Caml_option.some(content),
                target: props.target,
                onClick: onClick,
                onMouseEnter: onMouseEnter,
                disabled: disabled,
                "aria-expanded": ariaExpanded,
                id: id
              });
  } else {
    return JsxRuntime.jsx(ReactAriaComponents.Button, {
                children: content,
                className: (function (state) {
                    return TailwindMerge.twMerge([
                                styleFn({
                                      size: size,
                                      isFocusVisible: state.isFocusVisible
                                    }),
                                className
                              ]);
                  }),
                onClick: onClick,
                onMouseEnter: onMouseEnter,
                onFocus: onFocus,
                onBlur: onBlur,
                isDisabled: disabled,
                tabIndex: tabIndex,
                ariaExpanded: ariaExpanded,
                id: id,
                type: _type
              });
  }
}

var BaseButton = {
  make: ButtonsV5$BaseButton
};

function ButtonsV5$Button(props) {
  var __children = props.children;
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
  return JsxRuntime.jsx(ButtonsV5$BaseButton, {
              href: props.href,
              target: props.target,
              tabIndex: props.tabIndex,
              onClick: props.onClick,
              onMouseEnter: props.onMouseEnter,
              onFocus: props.onFocus,
              onBlur: props.onBlur,
              disabled: props.disabled,
              size: props.size,
              className: className,
              icon: props.icon,
              overlayText: props.overlayText,
              ariaExpanded: props.ariaExpanded,
              id: props.id,
              _type: props._type,
              children: Caml_option.some(children),
              styleFn: buttonBase
            });
}

var Button = {
  make: ButtonsV5$Button
};

function ButtonsV5$PrimaryButton(props) {
  var __children = props.children;
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
  return JsxRuntime.jsx(ButtonsV5$BaseButton, {
              href: props.href,
              target: props.target,
              tabIndex: props.tabIndex,
              onClick: props.onClick,
              onMouseEnter: props.onMouseEnter,
              disabled: props.disabled,
              size: props.size,
              className: className,
              icon: props.icon,
              overlayText: props.overlayText,
              ariaExpanded: props.ariaExpanded,
              id: props.id,
              _type: props._type,
              children: Caml_option.some(children),
              appearance: "primary",
              styleFn: buttonPrimary
            });
}

var PrimaryButton = {
  make: ButtonsV5$PrimaryButton
};

function ButtonsV5$SecondaryButton(props) {
  var __children = props.children;
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
  return JsxRuntime.jsx(ButtonsV5$BaseButton, {
              href: props.href,
              target: props.target,
              tabIndex: props.tabIndex,
              onClick: props.onClick,
              onMouseEnter: props.onMouseEnter,
              disabled: props.disabled,
              size: props.size,
              className: className,
              icon: props.icon,
              overlayText: props.overlayText,
              ariaExpanded: props.ariaExpanded,
              id: props.id,
              _type: props._type,
              children: Caml_option.some(children),
              appearance: "secondary",
              styleFn: buttonSecondary
            });
}

var SecondaryButton = {
  make: ButtonsV5$SecondaryButton
};

function ButtonsV5$DarkSecondaryButton(props) {
  var __children = props.children;
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
  return JsxRuntime.jsx(ButtonsV5$BaseButton, {
              href: props.href,
              target: props.target,
              tabIndex: props.tabIndex,
              onClick: props.onClick,
              onMouseEnter: props.onMouseEnter,
              disabled: props.disabled,
              size: props.size,
              className: className,
              icon: props.icon,
              overlayText: props.overlayText,
              ariaExpanded: props.ariaExpanded,
              id: props.id,
              _type: props._type,
              children: Caml_option.some(children),
              appearance: "secondary",
              styleFn: buttonDarkSecondary
            });
}

var DarkSecondaryButton = {
  make: ButtonsV5$DarkSecondaryButton
};

function ButtonsV5$CtaButton(props) {
  var __children = props.children;
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
  return JsxRuntime.jsx(ButtonsV5$BaseButton, {
              href: props.href,
              target: props.target,
              tabIndex: props.tabIndex,
              onClick: props.onClick,
              onMouseEnter: props.onMouseEnter,
              disabled: props.disabled,
              size: props.size,
              className: className,
              icon: props.icon,
              overlayText: props.overlayText,
              ariaExpanded: props.ariaExpanded,
              id: props.id,
              _type: props._type,
              children: Caml_option.some(children),
              appearance: "cta",
              styleFn: buttonCta
            });
}

var CtaButton = {
  make: ButtonsV5$CtaButton
};

function ButtonsV5$LinkButton(props) {
  var __children = props.children;
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
  return JsxRuntime.jsx(ButtonsV5$BaseButton, {
              href: props.href,
              target: props.target,
              tabIndex: props.tabIndex,
              onClick: props.onClick,
              onMouseEnter: props.onMouseEnter,
              disabled: props.disabled,
              size: props.size,
              className: className,
              icon: props.icon,
              overlayText: props.overlayText,
              ariaExpanded: props.ariaExpanded,
              id: props.id,
              _type: props._type,
              children: Caml_option.some(children),
              appearance: "link",
              styleFn: buttonLink
            });
}

var LinkButton = {
  make: ButtonsV5$LinkButton
};

function ButtonsV5$Link(props) {
  var __children = props.children;
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
  return JsxRuntime.jsx(ButtonsV5$BaseButton, {
              href: props.href,
              target: props.target,
              tabIndex: props.tabIndex,
              onClick: props.onClick,
              disabled: props.disabled,
              size: props.size,
              className: className,
              icon: props.icon,
              overlayText: props.overlayText,
              ariaExpanded: props.ariaExpanded,
              id: props.id,
              _type: props._type,
              children: Caml_option.some(children),
              appearance: "link",
              styleFn: buttonLink
            });
}

var Link$1 = {
  make: ButtonsV5$Link
};

function ButtonsV5$DangerButton(props) {
  var __children = props.children;
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
  return JsxRuntime.jsx(ButtonsV5$BaseButton, {
              href: props.href,
              target: props.target,
              tabIndex: props.tabIndex,
              onClick: props.onClick,
              onMouseEnter: props.onMouseEnter,
              disabled: props.disabled,
              size: props.size,
              className: className,
              icon: props.icon,
              overlayText: props.overlayText,
              ariaExpanded: props.ariaExpanded,
              id: props.id,
              _type: props._type,
              children: Caml_option.some(children),
              appearance: "danger",
              styleFn: buttonDanger
            });
}

var DangerButton = {
  make: ButtonsV5$DangerButton
};

function ButtonsV5$OutlineButton(props) {
  var __color = props.color;
  var __children = props.children;
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  var children = __children !== undefined ? Caml_option.valFromOption(__children) : null;
  var color = __color !== undefined ? __color : "Default";
  var tmp;
  tmp = color === "Default" ? "text-white disabled:opacity-50 hover:text-zinc-700 hover:bg-white" : "text-tan-blue-500 border-tan-blue-500 hover:text-white hover:bg-tan-blue-500 disabled:opacity-50";
  return JsxRuntime.jsx(ButtonsV5$BaseButton, {
              href: props.href,
              target: props.target,
              tabIndex: props.tabIndex,
              onClick: props.onClick,
              onMouseEnter: props.onMouseEnter,
              disabled: props.disabled,
              size: props.size,
              className: TailwindMerge.twMerge([
                    tmp,
                    className
                  ]),
              icon: props.icon,
              overlayText: props.overlayText,
              ariaExpanded: props.ariaExpanded,
              id: props.id,
              _type: props._type,
              children: Caml_option.some(children),
              appearance: "outline",
              styleFn: buttonOutline
            });
}

var OutlineButton = {
  make: ButtonsV5$OutlineButton
};

var Icon;

exports.Icon = Icon;
exports.Styles = Styles;
exports.BaseButton = BaseButton;
exports.Button = Button;
exports.PrimaryButton = PrimaryButton;
exports.SecondaryButton = SecondaryButton;
exports.DarkSecondaryButton = DarkSecondaryButton;
exports.CtaButton = CtaButton;
exports.LinkButton = LinkButton;
exports.Link = Link$1;
exports.DangerButton = DangerButton;
exports.OutlineButton = OutlineButton;
/* buttonBase Not a pure module */
